<script>

    import { toast } from 'bulma-toast'
    import { providersStore, providerStore, modalStore } from '../stores'

    import ProvidersService from '../$services/providers.service'

    import Form from '../$components/form.svelte'
    import Select from '../$components/select.svelte'
    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let loading = false
    let data = {
        name: $providerStore.name,
        status: $providerStore.status
    }
    
    async function updateProvider() {

        loading = true
        const resp = await ProvidersService.updateProvider(data._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.replace(resp.data)
        providerStore.set(resp.data)

        toast({message: 'Proveedor actualizado', type: 'is-success'})
        modalStore.set('provider_modal')
    }

</script>

<Form on:submit={updateProvider} { loading } >
    <div class="columns">
        <div class="column">
            <Select bind:value={ data.status } 
                label="Estatus"
                options={[
                    {value: 'enabled', text: 'Habiltado'},
                    {value: 'disabled', text: 'Deshabilitado'},
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.name} label="Proveedor" placeholder="Proveedor" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <ButtonModal modalId="provider_modal" text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>